import { HomeViewParticipantFragment } from './searchParticipants.generated'

type Participant = HomeViewParticipantFragment

export const ROLE_FILTERS = ['primaryProvider', 'otherCareTeamMember'] as const

export type RoleFilter = (typeof ROLE_FILTERS)[number]

export const ROLE_FILTER_LABELS: Record<RoleFilter, string> = {
  primaryProvider: 'Primary provider',
  otherCareTeamMember: 'Other care team member',
}

/**
 * The home list only contains the coach's own care-team patients, so anyone the coach is not
 * primary for is someone whose care team they are otherwise on.
 */
const getParticipantRoleFilter = (participant: Participant, coachID: string): RoleFilter =>
  participant.careTeam?.some((member) => member.coachID === coachID && member.isPrimary)
    ? 'primaryProvider'
    : 'otherCareTeamMember'

export const participantMatchesRoleFilters = (
  participant: Participant,
  coachID: string,
  selectedRoles: ReadonlyArray<RoleFilter>
) => selectedRoles.length === 0 || selectedRoles.includes(getParticipantRoleFilter(participant, coachID))
